import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";
import { TimeKeepingMonthResponse } from "core/http/service/decleareLeave/resTypes";
import moment from "moment";

interface InitialState {
  status?: ReduxStateType;
  data: TimeKeepingMonthResponse;
  month: number;
  year: number;
}

const initialState: InitialState = {
  status: ReduxStateType.LOADING,
  data: {
    confirmStatus: "",
    leaveReasons: [
      {
        reasonCode: "",
        reasonName: "",
        totalDays: 0,
      },
    ],
    message: "",
    totalWorkDays: 0,
    workDays: {},
    fromDate: "",
    toDate: "",
  },
  month: moment().month() + 1,
  year: moment().year(),
};

const getTimeCheckingMonthSlice = createSlice({
  name: "getTimeKeeping",
  initialState,
  reducers: {
    setMonthYearTimeCheckingMonth: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    getTimeCheckingMonthStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getTimeCheckingMonthSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getTimeCheckingMonthFailed: (state, action) => {
      state = {
        status: ReduxStateType.ERROR,
        data: initialState.data,
        month: initialState.month,
        year: initialState.year,
      };
    },
  },
});

export const {
  setMonthYearTimeCheckingMonth,
  getTimeCheckingMonthStart,
  getTimeCheckingMonthSuccess,
  getTimeCheckingMonthFailed,
} = getTimeCheckingMonthSlice.actions;

export default getTimeCheckingMonthSlice.reducer;
